import React, { Component } from "react";
import axios from "axios";

class DossierScheduledDocumentRequestsTable extends Component {
    async editDate(request) {
        const result = await swal.fire({
            title: 'Editar fecha de solicitud',
            html: '<div class="input-icon input-icon-right"><input id="scheduledRequestDate" type="text" class="form-control text-muted" readonly aria-label="Fecha de solicitud"><span><i class="flaticon2-calendar-9 text-primary icon-md"></i></span></div>',
            onOpen: () => {
                const localDate = value => {
                    const [year, month, day] = value.substring(0, 10).split('-').map(Number);
                    return new Date(year, month - 1, day);
                };
                $('#scheduledRequestDate').datepicker({
                    format: 'dd/mm/yyyy', startDate: localDate(request.earliest_date),
                    autoclose: true, todayHighlight: true, container: swal.getPopup(),
                }).datepicker('setDate', localDate(request.scheduled_for));
            },
            onClose: () => $('#scheduledRequestDate').datepicker('destroy'),
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            customClass: { title: 'font-size-h5 font-weight-bold text-dark-75', confirmButton: 'btn font-weight-bold btn-primary', cancelButton: 'btn font-weight-bold btn-secondary' },
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !swal.isLoading(),
            preConfirm: async () => {
                const selected = $('#scheduledRequestDate').datepicker('getDate');
                const date = selected && `${selected.getFullYear()}-${String(selected.getMonth() + 1).padStart(2, '0')}-${String(selected.getDate()).padStart(2, '0')}`;
                if (!date || date < request.earliest_date) {
                    swal.showValidationMessage('Selecciona una fecha futura a partir de mañana.');
                    return false;
                }
                try {
                    await axios.patch(`/api/dossiers/${this.props.personProviderId}/scheduled-document-requests/${request.id}`, { scheduled_for: date });
                    return true;
                } catch (error) {
                    swal.showValidationMessage(error.response?.data?.errors?.scheduled_for?.[0] || error.response?.data?.message || 'No se pudo actualizar la solicitud.');
                    return false;
                }
            },
        });
        if (result.isConfirmed) {
            this.props.onChange();
            await swal.fire({
                text: 'Se ha actualizado la fecha de solicitud.',
                icon: 'success',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: { confirmButton: 'btn font-weight-bold btn-primary' },
            });
        }
    }

    async cancel(request) {
        const result = await swal.fire({
            text: '¿Estás seguro que deseas cancelar la solicitud programada de este documento?',
            icon: 'question',
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            customClass: { confirmButton: 'btn font-weight-bold btn-primary', cancelButton: 'btn font-weight-bold btn-secondary' },
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !swal.isLoading(),
            preConfirm: async () => {
                try {
                    await axios.delete(`/api/dossiers/${this.props.personProviderId}/scheduled-document-requests/${request.id}`);
                    return true;
                } catch (error) {
                    swal.showValidationMessage(error.response?.data?.message || 'No se pudo cancelar la solicitud.');
                    return false;
                }
            },
        });
        if (result.isConfirmed) {
            this.props.onChange();
            await swal.fire({
                text: 'Se ha cancelado la solicitud programada del documento.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: { confirmButton: 'btn font-weight-bold btn-primary' },
            });
        }
    }

    formatDate(date) {
        const [year, month, day] = date.substring(0, 10).split('-');
        return `${day}/${month}/${year}`;
    }

    render() {
        const documents = this.props.documents.filter(request => request.document && (
            this.props.type === 'only' ? request.document.frequency === 'once' : request.document.frequency !== 'once'
        ));
        if (!documents.length) return null;

        return (
            <>
                <tr>
                    <td colSpan="5">
                        <div className="separator separator-solid separator-border-1 mt-5 mb-2" style={{ borderBottomColor: "#dbcbfd" }}></div>
                    </td>
                </tr>
                <tr>
                    <td colSpan="5">
                        <div className="py-5">
                            <h5 className="text-muted">Documentos programados</h5>
                            <div className="text-muted font-size-sm">Solicitudes pendientes de ejecución. No contabilizan como documentos solicitados.</div>
                        </div>
                    </td>
                </tr>
                {documents.map((request) => (
                    <tr key={request.id}>
                        <td style={{width: "20px"}}>
                            <div className="symbol symbol-40">
                                <div className="symbol-label bg-light text-muted font-weight-bolder">
                                    {request.document.title[0]}
                                </div>
                            </div>
                        </td>
                        <td colSpan="3" className="text-muted">
                            {request.document.title}
                            <div className="text-muted font-size-sm">
                                Se solicitará el {this.formatDate(request.scheduled_for)}
                            </div>
                        </td>
                        <td>
                            {request.can_manage && <div className="d-flex justify-content-end">
                                <div className="dropdown dropdown-inline">
                                    <button type="button" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Acciones <i className="flaticon2-down icon-sm ml-2"></i>
                                    </button>
                                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg">
                                        <ul className="navi navi-hover">
                                            <li className="navi-item">
                                                <button type="button" className="navi-link py-4 btn btn-block text-left" onClick={() => this.editDate(request)}>
                                                    <span className="navi-icon mr-5 text-center"><i className="flaticon2-calendar-9 text-primary icon-md"></i></span>
                                                    <span className="navi-text text-secondary">Editar fecha de solicitud</span>
                                                </button>
                                            </li>
                                            <li className="navi-item">
                                                <button type="button" className="navi-link py-4 btn btn-block text-left" onClick={() => this.cancel(request)}>
                                                    <span className="navi-icon mr-5 text-center"><i className="flaticon-delete text-primary icon-md"></i></span>
                                                    <span className="navi-text text-secondary">Cancelar solicitud</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>}
                        </td>
                    </tr>
                ))}
            </>
        );
    }
}

export default DossierScheduledDocumentRequestsTable;
